/* eslint-disable @typescript-eslint/no-explicit-any */
import cx from 'classnames';
import React from 'react';
import ReactSelect, { components, Props, OptionProps, SingleValueProps } from 'react-select';
import { DropdownIndicatorProps } from 'react-select/dist/declarations/src/components/indicators';
import { MultiValueRemoveProps } from 'react-select/dist/declarations/src/components/MultiValue';

import ArrowDropDown from '../Icons/ArrowDropDown';
import ArrowDropUp from '../Icons/ArrowDropUp';

import s from './select.module.css';

export interface SelectProps extends Props {
    label?: {
        name?: string;
        value: string;
    };
    containerClassName?: string;
}

const DropdownIndicator = (props: DropdownIndicatorProps<any, any>) => (
    <components.DropdownIndicator {...props}>
        {props.isFocused && props.selectProps.menuIsOpen ? <ArrowDropUp /> : <ArrowDropDown />}
    </components.DropdownIndicator>
);

const Option = (props: OptionProps<any, any> & { isFormatted: boolean }) => {
    const label = props.isFormatted ? (
        props.children
    ) : (
        <span title={props.data.label}>{props.data.label}</span>
    );
    return (
        <components.Option {...props}>
            {props.isMulti && (
                <React.Fragment>
                    <input type="checkbox" checked={props.isSelected} readOnly />
                    <label>{label}</label>
                </React.Fragment>
            )}
            {!props.isMulti && label}
        </components.Option>
    );
};

const SingleValue = (props: SingleValueProps<any>) => (
    <components.SingleValue {...props}>
        <span title={props.data.label}>{props.data.label}</span>
    </components.SingleValue>
);

const MultiValueRemove = (props: MultiValueRemoveProps<any>) => (
    <components.MultiValueRemove {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="18"
            height="18"
            viewBox="0 0 18 18"
        >
            <defs>
                <path
                    id="a"
                    d="M12.21 4.12l-.9-.9L7.7 6.8 4.12 3.2l-.9.91 3.59 3.6-3.6 3.59.91.9 3.6-3.59 3.59 3.6.9-.91-3.59-3.6z"
                />
                <path id="c" d="M0 0h32.14v32.14H0z" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <rect width="18" height="18" fill="#ADB5BD" fillRule="nonzero" rx="9" />
                <g transform="translate(1.29 1.29)">
                    <mask id="b" fill="#fff">
                        <use xlinkHref="#a" />
                    </mask>
                    <g mask="url(#b)">
                        <use fill="#FFF" transform="translate(-8.36 -8.36)" xlinkHref="#c" />
                    </g>
                </g>
            </g>
        </svg>
    </components.MultiValueRemove>
);

const Select = ({ label, containerClassName, ...props }: SelectProps) => (
    <div className={cx(s.selectContainer, containerClassName)}>
        {label && (
            <label className="body ink" htmlFor={label.name || 'select'}>
                {label.value}
            </label>
        )}
        <ReactSelect
            blurInputOnSelect
            className={s.select}
            classNamePrefix={'select'}
            menuPlacement="auto"
            components={{
                DropdownIndicator,
                Option: (optionProps) => (
                    <Option isFormatted={!!props.formatOptionLabel} {...optionProps} />
                ),
                SingleValue,
                MultiValueRemove,
            }}
            name={label ? label.name : 'select'}
            hideSelectedOptions={false}
            {...props}
        />
    </div>
);

export default Select;
